export default __webpack_public_path__ + "static/media/brendan.d3111af7.png";